import { render, staticRenderFns } from "./FormJournalItem.vue?vue&type=template&id=746b21c1&"
import script from "./FormJournalItem.vue?vue&type=script&lang=js&"
export * from "./FormJournalItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports